const MOBILE_UA = /(mobi|ipod|phone|blackberry|opera mini|fennec|minimo|symbian|psp|nintendo ds|archos|skyfire|puffin|blazer|bolt|gobrowser|iris|maemo|semc|teashark|uzard)/
const TABLET_UA = /(ipad|tablet|(android(?!.*mobile))|(windows(?!.*phone)(.*touch))|kindle|playbook|silk|(puffin(?!.*(IP|AP|WP))))/

const DEVICES = {
  MOBILE: 1,
  TABLET: 2,
  DESKTOP: 3
}

class DeviceService {
  constructor ($rootScope, $log) {
    'ngInject'
    this.ua = navigator.userAgent.toLowerCase()
    this.device = DEVICES.DESKTOP
    if (TABLET_UA.test(this.ua)) {
      this.device = DEVICES.TABLET
    } else if (MOBILE_UA.test(this.ua)) {
      this.device = DEVICES.MOBILE
    }

    this.windowWidth = this.width
    window.addEventListener('resize', () => {
      // $log.debug('resize event fired')
      // $log.debug('windowWidth', this.windowWidth)
      // $log.debug('width', this.width)
      if (this.windowWidth !== this.width) {
        this.windowWidth = this.width
        $rootScope.$broadcast('width:resized')
      }
    })
  }

  getAtcDeviceId () {
    if (this.isMobile()) {
      return 2
    } else if (this.isTablet()) {
      return 4
    } else {
      return 1
    }
  }

  get width () {
    // return document.body.clientWidth
    return window.innerWidth
  }

  isSmallScreen () {
    return this.width < 468 || this.width >= 650 && this.width < 664
  }

  isMediumScreen () {
    return this.width >= 468 && this.width < 598 || this.width >= 664 && this.width < 847
  }

  isLargeScreen () {
    return this.width >= 598 && this.width < 650 || this.width >= 847
  }

  isMobile () {
    return this.device === DEVICES.MOBILE
  }

  isTablet () {
    return this.device === DEVICES.TABLET
  }

  isDesktop () {
    return this.device === DEVICES.DESKTOP
  }
}

export default DeviceService



// WEBPACK FOOTER //
// ./src/app/services/device/device.service.js